<svelte:options
	customElement={{
		tag: 'image-element',
		shadow: 'none',
		props: {
			src: { reflect: true },
			alt: { reflect: true },
			class: { reflect: true },
			style: { reflect: true },
			width: { reflect: true },
			height: { reflect: true }
		}
	}}
/>

<script lang="ts">
	import { browser } from '$app/environment';
	import BiggerPicture from 'bigger-picture';
	import { sizeUpImg, setSizeImg } from '$lib/utils.js';

	import 'bigger-picture/css';
	import { onMount } from 'svelte';
	import { cn } from '$lib/utils.js';

	let {
		src,
		alt,
		class: _class,
		wrapperClass,
		width,
		height,
		style
	}: {
		src: string;
		alt?: string | null;
		class?: string;
		wrapperClass?: string | null;
		style?: string;
		width?: string;
		height?: string;
	} = $props();
	let bp: ReturnType<typeof BiggerPicture>;

	// dont need lightbox for small images like icons
	let bigEnough = !width || parseInt(width) > 64;

	onMount(() => {
		if (!src.endsWith('.svg') && browser && bigEnough) {
			bp = BiggerPicture({ target: document.body });
		}
	});

	const openImage = () => {
		if (!src.endsWith('.svg') && bigEnough) {
			bp?.open({
				items: [{ img: sizeUpImg(src) }]
			});
		}
	};

	let error = $state(false);
	// let showError = $state(false);

	let original = $derived(sizeUpImg(src));
	let medium = $derived(setSizeImg(original, 'medium'));
	let large = $derived(setSizeImg(original, 'large'));
	let xlarge = $derived(error ? original : setSizeImg(original, 'xlarge'));

	console.log(src);

	const onerror = () => {
		if (error) return;
		error = true;
		// if (original !== large) {
		// 	showError = true;
		// }
	};
</script>

{#snippet Image()}
	{#if !src.endsWith('.svg')}
		<picture>
			<source media="(max-width: 480px)" srcset={`${medium}, ${large} 2x`} />
			<source media="(min-width: 768px)" srcset={`${large}, ${xlarge} 2x`} />
			<source media="(min-width: 1024px)" srcset={`${xlarge}, ${original} 2x`} />
			<source media="(min-width: 1536px)" srcset={original} />
			<img {src} {alt} class={cn(_class, '!aspect-auto')} {width} {height} {style} {onerror} />
		</picture>
	{:else}
		<img {src} {alt} class={cn(_class, '!aspect-auto')} {width} {height} {style} {onerror} />
	{/if}
{/snippet}

{#if !src.endsWith('.svg')}
	<button
		onclick={openImage}
		class={cn(
			'flex justify-center',
			bigEnough ? 'hover:cursor-zoom-in' : 'cursor-default',
			wrapperClass
		)}
	>
		{@render Image()}
	</button>
{:else}
	{@render Image()}
{/if}
